import React, { useState, useContext, useEffect } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { SingleSelect } from '@boatsetter-backup/js-component-lib';
import { AppContext } from '~/providers/AppProvider';
import { BoatsColumns } from '~/api/client/api';
import { shallowEqual } from '~/utils/objects';
import { Trans } from '@lingui/react';

interface ValueType {
  column: BoatsColumns;
  asc: boolean;
}
interface Option {
  value: ValueType;
  label: any;
}

const sortingOptions: Option[] = [
  {
    value: { column: BoatsColumns.SortPriority, asc: false },
    label: <Trans id="boatsSort.options.recommended" />,
  },
  {
    value: { column: BoatsColumns.Id, asc: false },
    label: <Trans id="boatsSort.options.newest" />,
  },
  {
    value: { column: BoatsColumns.BoatLength, asc: false },
    label: <Trans id="boatsSort.options.largeToSmall" />,
  },
  {
    value: { column: BoatsColumns.BoatLength, asc: true },
    label: <Trans id="boatsSort.options.smallToLarge" />,
  },
  {
    value: { column: BoatsColumns.Price, asc: false },
    label: <Trans id="boatsSort.options.hightToLow" />,
  },
  {
    value: { column: BoatsColumns.Price, asc: true },
    label: <Trans id="boatsSort.options.lowToHigh" />,
  },
];

const BoatsSort = () => {
  const router = useRouter();
  const appCtx = useContext(AppContext);
  const [sortObj, setSortObj] = useState(null);

  useEffect(() => {
    getSortObj();
  }, [router.query]);

  const getSortObj = () => {
    const asc = router.query.ascending !== undefined ? router.query.ascending === 'true' : true;
    const column =
      router.query.sortBy !== undefined ? BoatsColumns[String(router.query.sortBy)] : BoatsColumns.SortPriority;

    const valueObj = { column, asc };

    sortingOptions.forEach((option) => {
      if (shallowEqual(option.value, valueObj)) {
        setSortObj(option);
      }
    });
  };

  const changeSortingOption = (newSortingOption: Option) => {
    appCtx.actions.setLoading(true);
    setSortObj(newSortingOption);

    const currentQueries = router.query;
    delete currentQueries.pageNumber;

    router.replace({
      pathname: router.pathname,
      query: {
        ...currentQueries,
        sortBy: newSortingOption.value.column,
        ascending: newSortingOption.value.asc,
      },
    });
  };

  return (
    <Wrapper>
      <div style={{ width: '100%' }}>
        <SingleSelect
          instanceId={'sort_select'}
          options={sortingOptions}
          value={sortObj}
          onChange={changeSortingOption}
        />
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  margin-bottom: 20px;
  justify-content: flex-end;
  width: 400px;

  div[class*='control']:hover {
    background-color: #8e9697;
    color: #fff !important;
    transition: all 0.3s ease;

    div[class*='singleValue'] {
      color: #fff !important;
    }
  }

  @media (max-width: 950px) {
    display: none;
  }

  span[class*='indicatorSeparator'] {
    display: none;
  }

  div[class*='control'] {
    box-shadow: none !important;
    border: 1px solid #8e9697;
  }

  div[class*='-menu'] {
    z-index: 999;
  }
`;

export default BoatsSort;
